import React from 'react';

const TextArea = ({ name, label, error, divClasses, ...rest }) => {
  const { required, type } = rest;
  return (
    <div className='mb-3'>
      <label htmlFor={name} className='form-label'>
        {label}
        <span className='required'>{required ? ' *' : ''}</span>
      </label>
      <textarea id={name} name={name} placeholder={label} {...rest} />
      {error && <div className='alert alert-danger'>{error}</div>}
    </div>
  );
};

export default TextArea;
